/* eslint-disable no-return-assign */
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IconButton, Grid, Badge, Typography, Link, Button as ButtonCreate } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { setStep5, setStep4, setStep3, setStep2, setStep1 } from '../../modules/story/actions'
import { googleId, signInAction } from '../../modules/session/actions'
import { Button } from '../UI/index'
import { Menu, LoginModal } from 'components'
import api from '../../api/auth'
import logoHeader from '../../assetss/img/FullHD.png'
import logoHeaderPressed from '../../assetss/img/tellMeActive.png'
import edit from '../../assetss/img/edit.svg'
import editHover from '../../assetss/img/editHover.svg'
import meetIcon from '../../assetss/img/meetings.svg'
import meetIconActive from '../../assetss/img/meetIconActive.svg'
import notiIcon from '../../assetss/img/notification.svg'
import introIcon from '../../assetss/img/introIcon.svg'
import notIconActive from '../../assetss/img/notIconActive.svg'
import c from 'classnames'
import './index.scss'

const Header = ({ open, meetMessage, notifications, setOpen, setOpenSide, openSide, openLogin, setOpenLogin }) => {
  const history = useHistory()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const { user } = useSelector(({ session }) => session)
  const [textModal, setTextModal] = useState({
    textTitle: 'To continue, log in to tellMe.place',
    textBtn: 'Log in with Google',
  })

  // const changeTextLoginModal = () => {
  //   setTextModal({
  //     textTitle: 'To continue, log in to tellMe.place',
  //     textBtn: 'Log in with Google',
  //   })
  // }

  // const changeTextSignUpModal = () => {
  //   setTextModal({
  //     textTitle: 'To continue, sign up to tellMe.place',
  //     textBtn: 'Sign up with Google',
  //   })
  // }

  const goTo = path => history.push(path)

  const onCreateHandler = () => {
    dispatch(setStep1(null))
    dispatch(setStep2(null))
    dispatch(setStep3(null))
    dispatch(setStep4(null))
    dispatch(setStep5(null))
    goTo('/new-story/step/1')
  }

  const onSignUp = () => {
    api.loginGuoogle().then(e => {
      dispatch(googleId(e?.data?.url))
      if (e?.data?.url) {
        window.location.href = e?.data?.url
        dispatch(signInAction(e?.data))
      }
    })
  }

  return (
    <Grid
      className={c(
        'containerHeader',
        pathname?.split('/')?.[1] === 'story' && 'updateMargin',
        pathname?.split('/')?.[1] === 'storyPrevios' && 'updateMargin',
        pathname === '/myStory' && 'updateMargin',
        pathname === '/myBookmarks' && 'updateMargin',
      )}
      container
      alignItems='center'
      justify='center'
    >
      {/* <LoginModal open={openLogin} setOpen={setOpenLogin} onSignUp={onSignUp} textModal={textModal} /> */}

      <header className='headerWrapper'>
        <div className='headerLeft'>
          <img
            onMouseDown={e => e.target.src = logoHeaderPressed}
            onClick={e => {
              e.target.src = logoHeader
              goTo('/')
            }}
            className='logoHeader'
            src={logoHeader}
            alt='logoHeader'
          />
          <ButtonCreate
            className='headerBtn' onClick={onCreateHandler}
            startIcon={(
              <>
                <img src={edit} className='btnImage' />
                <img src={editHover} className='btnImageHover' />
              </>
            )}
          >
            Tell my story
          </ButtonCreate>

          <Link href='https://tellme-place.info/introduction' target='_blank' className='introBtn'>
            <img src={introIcon} alt='introIcon' />
            <span className='introText'>Intro</span>
          </Link>
        </div>
        <div className='wrapperMenu'>
          <Menu />
        </div>
        {user?.accessKey ? (
          <div className='headerRightUser'>
            <div
              className='schadle'
              onClick={() => {
                if (pathname === '/chat/meeting-chat') {
                  goTo('/')
                } else {
                  goTo('/chat/meeting-chat')
                }
              }}
            >
              <img className='schadleMeetIcon' src={pathname?.split('/')?.[1] === 'chat' ? meetIconActive : meetIcon} />
              <Badge
                badgeContent={meetMessage?.length}
                classes={{ badge: 'customBadge' }}
              >
                <Typography className={c('description', pathname?.split('/')?.[1] === 'chat' && 'descriptionActive')}>Meetings</Typography>
              </Badge>
            </div>
            <div
              className='schadle'
              onClick={() => {
                if (open) {
                  setOpen(false)
                }
                setOpenSide(prev => !prev)
              }}
            >
              {openSide ? (
                <img src={notIconActive} />
              ) : <img src={notiIcon} />}
              <Badge
                badgeContent={+notifications?.length > 10 ? '10+' : +notifications?.length || null}
                classes={{ badge: 'customBadge' }}
              >
                <p className={c('description', openSide && 'descriptionActive')}>Notifications</p>
              </Badge>
            </div>
            <IconButton
              onClick={() => {
                if (openSide) {
                  setOpenSide(false)
                }
                setOpen(prev => !prev)
              }}
              className='iconBtn'
            >
              <div className='user'>
                <span className='userBlock'>{user?.user?.name?.charAt(0)}</span>
              </div>
            </IconButton>
          </div>
        ) : (
          <div className='headerRight'>
            <Button
              // onClick={() => {
              //   setOpenLogin(true)
              //   changeTextLoginModal()
              // }}
              onClick={onSignUp}
              className='singUpBtn'
            >
              Log in
            </Button>
            <Button
              // onClick={() => {
              //   changeTextSignUpModal()
              //   setOpenLogin(true)
              // }}
              className='logInBtn'
              onClick={onSignUp}
            >
              Sign up
            </Button>
          </div>
        )}
      </header>
    </Grid>
  )
}

export default Header
